/* ===== MedBound — selettore formato (sostituisce variant-selects del tema) =====
   Al cambio formato aggiorna etichetta, prezzo, galleria e mantiene attivo il
   bottone "Aggiungi al carrello". Niente fetch alla Section Rendering API e
   niente riscrittura dell'URL (il tema le faceva entrambe e sullo snapshot
   statico rompevano pagina e carrello). Pronto per la conversione a Shopify:
   la mappa PRICES/MEDIA corrisponde alle varianti + featured_image. */
(function(){
  const EUR = v => "€" + v.toFixed(2).replace(".", ",");
  // prezzi per formato; c = prezzo barrato (UVP/Regulärer Preis) -> sconto ~42-44%
  const PRICES = {
    single: { ebook:{p:49.99, c:89.99}, spiral:{p:79.99, c:139.99}, combo:{p:84.99, c:149.99} },
    bundle: { ebook:{p:149.99, c:359.96}, spiral:{p:199.99, c:559.96}, combo:{p:219.99, c:599.96} }
  };
  // indice slide della galleria per formato (ebook -> mockup tablet)
  // ordine galleria uniforme: 0=spiral, 1=indici, 2=ebook(tablet), 3-5=spread, 6=finale
  const MEDIA = {
    anatomie: {ebook:2, spiral:0, combo:0},
    bundle:   {ebook:2, spiral:0, combo:0},
    default:  {ebook:2, spiral:0, combo:0}
  };
  const page = (location.pathname.split("/").filter(Boolean).pop()||"").replace(/\.html$/,"");
  const kind = page==="bundle" ? "bundle" : "single";
  const media = MEDIA[page] || MEDIA.default;

  function fmtOf(v){
    v = (v||"").toLowerCase();
    // combo = qualsiasi etichetta che combina due formati (ha un "+"): es.
    // "E-Book + Spiralbindung", "Spiralbindung + Digital", "Ebook + Spiral".
    if(v.includes("+") || v.includes("combo")) return "combo";
    if(v.includes("spiral")) return "spiral";
    return "ebook";
  }

  // sul tema Shopify i prezzi arrivano dalle varianti vere ({{ product | json }})
  function priceEntry(fmt){
    const P = window.MB_PRODUCT;
    if(P && P.variants && P.variants.length){
      const v = P.variants.find(v => fmtOf(v.option1 || v.title) === fmt);
      if(v) return { p: v.price/100, c: v.compare_at_price ? v.compare_at_price/100 : null };
    }
    const e = PRICES[kind][fmt];
    return { p: e.p, c: e.c || null };
  }
  function minPrice(){
    const P = window.MB_PRODUCT;
    if(P && P.variants && P.variants.length){
      return Math.min.apply(null, P.variants.map(v => v.price)) / 100;
    }
    return PRICES[kind].ebook.p;
  }

  function renderPrice(fp, e){
    if(e.c){
      fp.classList.add("f-price--on-sale");
      fp.innerHTML = '<div class="f-price__sale">'+
        '<span class="visually-hidden visually-hidden--inline">Sonderpreis</span>'+
        '<span class="f-price-item f-price-item--sale">'+EUR(e.p)+'</span>'+
        '<span class="visually-hidden visually-hidden--inline">Regulärer Preis</span>'+
        '<span class="f-price-item f-price-item--regular"><s>'+EUR(e.c)+'</s></span></div>';
    } else {
      fp.classList.remove("f-price--on-sale");
      fp.innerHTML = '<div class="f-price__regular">'+
        '<span class="visually-hidden visually-hidden--inline">Regulärer Preis</span>'+
        '<span class="f-price-item f-price-item--regular">'+EUR(e.p)+'</span></div>';
    }
  }

  function slideGallery(idx){
    const viewer = document.querySelector(".product__media-gallery-viewer");
    if(!viewer || idx==null) return;
    const sw = viewer.swiper;
    if(sw){ sw.params && sw.params.loop ? sw.slideToLoop(idx) : sw.slideTo(idx); return; }
    // fallback: clic sulla thumbnail corrispondente
    const thumbs = document.querySelectorAll(".product__media-gallery .swiper-thumbs .swiper-slide, .media-gallery__thumbnail");
    if(thumbs[idx]) thumbs[idx].click();
  }

  function update(moveGallery){
    const checked = document.querySelector('input[name^="Format"]:checked');
    if(!checked){
      // nessun formato scelto: prezzo "da ..." e nessuna etichetta
      document.querySelectorAll("[data-selected-swatch-value]").forEach(el=>{ el.textContent = ""; });
      document.querySelectorAll(".product__block--price .f-price").forEach(fp=>{
        fp.classList.remove("f-price--on-sale");
        fp.innerHTML = '<div class="f-price__regular">'+
          '<span class="f-price-item f-price-item--regular">ab '+EUR(minPrice())+'</span></div>';
      });
      renderSticky(); // la sticky bar mostra il prezzo del suo formato, non "ab ..."
      updateKlarna(minPrice());
      return;
    }
    // la scelta è valida: via l'avviso "seleziona un formato"
    document.querySelectorAll(".mb-fmt-err").forEach(el=>el.remove());
    document.querySelectorAll(".mb-fmt-required").forEach(el=>el.classList.remove("mb-fmt-required"));
    const fmt = fmtOf(checked.value);
    const entry = priceEntry(fmt);
    // etichetta "Formato: X"
    document.querySelectorAll("[data-selected-swatch-value]").forEach(el=>{ el.textContent = checked.value; });
    // prezzo principale
    document.querySelectorAll(".product__block--price .f-price").forEach(fp=>renderPrice(fp, entry));
    // sincronizza la sticky bar sullo stesso formato
    selectStickyFmt(fmt); renderSticky();
    updateKlarna(entry.p);
    // il bottone resta sempre acquistabile
    document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(b=>{
      b.disabled = false;
      const sp = b.querySelector("span");
      if(sp && !/in den warenkorb/i.test(sp.textContent)) sp.textContent = "In den Warenkorb";
    });
    // immagine del formato selezionato
    if(moveGallery) slideGallery(media[fmt]);
  }

  // ===== Sticky bar: prezzo coerente col formato del suo <select> + default ebook + mobile =====
  function stickySelect(){ return document.querySelector(".sticky-atc-bar__variant-select"); }
  function stickyFmt(){ const s=stickySelect(); if(!s) return null; const o=s.options[s.selectedIndex]; return o?fmtOf(o.textContent):null; }
  function renderSticky(){
    const fmt=stickyFmt(); if(!fmt) return;
    document.querySelectorAll(".sticky-atc-bar .f-price").forEach(fp=>renderPrice(fp, priceEntry(fmt)));
  }
  function selectStickyFmt(fmt){
    const s=stickySelect(); if(!s) return;
    for(let i=0;i<s.options.length;i++){ if(fmtOf(s.options[i].textContent)===fmt){ if(s.selectedIndex!==i) s.selectedIndex=i; return; } }
  }
  function setupSticky(){
    const bar=document.querySelector(".sticky-atc-bar"); if(!bar) return;
    if(!document.getElementById("mb-sticky-css")){
      const st=document.createElement("style"); st.id="mb-sticky-css";
      st.textContent=
        ".sticky-atc-bar .f-price{margin:0;white-space:nowrap}"+
        ".mb-sticky-price-m{display:none}"+
        "@media(max-width:767px){"+
          ".sticky-atc-bar__inner{gap:10px}"+
          ".sticky-atc-bar__form{flex:1 1 auto;justify-content:flex-end!important;gap:10px!important;flex-wrap:nowrap}"+
          ".mb-sticky-price-m{display:flex;align-items:center;font-weight:800;font-size:15px}"+
          ".mb-sticky-price-m .f-price-item--regular s{font-size:12px;opacity:.6;font-weight:600;margin-left:4px}"+
          ".mb-sticky-price-m .f-price__sale{display:flex;align-items:baseline;gap:4px;flex-wrap:wrap;line-height:1.05}"+
          ".sticky-atc-bar__variant-select{min-width:0;max-width:128px;font-size:13px;padding-right:24px}"+
          ".sticky-atc-bar .product-form__submit{width:auto!important;white-space:nowrap;padding-left:16px;padding-right:16px}"+
          ".sticky-atc-bar .product-form__button-dynamic{display:none!important}"+
        "}";
      document.head.appendChild(st);
    }
    // prezzo visibile su mobile (quello desktop sta dentro un blocco .hidden md:flex)
    if(!bar.querySelector(".mb-sticky-price-m")){
      const mp=document.createElement("div"); mp.className="f-price mb-sticky-price-m";
      const form=bar.querySelector(".sticky-atc-bar__form");
      if(form) form.insertBefore(mp, form.firstChild);
    }
    selectStickyFmt("ebook");   // default: il formato piu economico
    renderSticky();
    const s=stickySelect();
    if(s) s.addEventListener("change", function(){
      renderSticky();
      const fmt=stickyFmt();
      const r=[].slice.call(document.querySelectorAll('input[name^="Format"]')).find(x=>fmtOf(x.value)===fmt);
      if(r && !r.checked){ r.checked=true; update(true); }
    });
  }

  // colori brand (#74BDEA su announcement bar + bottone carrello) + widget Klarna
  function injectMbStyle(){
    if(document.getElementById("mb-style")) return;
    var st=document.createElement("style"); st.id="mb-style";
    st.textContent=
      ".announcement-bar{background:#74BDEA!important}"+
      ".product-form__submit,.product-form__submit.btn,.product-form__submit.btn--secondary{background:#74BDEA!important;border-color:#74BDEA!important;color:#fff!important}"+
      ".mb-klarna{display:flex;align-items:center;gap:7px;flex-wrap:wrap;margin:12px 0 0;font-size:13.5px;color:#52606d;font-family:var(--font-body-family,Montserrat,sans-serif)}"+
      ".mb-klarna b{font-weight:800;color:#1E4D6F}"+
      ".mb-kl-logo{height:20px;width:auto;display:inline-block;vertical-align:middle}"+
      ".mb-kl-fallback{background:#FFB3C7;color:#17120f;font-weight:800;border-radius:5px;padding:2px 8px;font-size:12.5px;letter-spacing:.2px}";
    document.head.appendChild(st);
  }
  function getKlarnaEl(){
    var el=document.querySelector(".mb-klarna");
    if(el) return el;
    var price=document.querySelector(".product__block--price"); if(!price) return null;
    el=document.createElement("div"); el.className="mb-klarna";
    el.innerHTML='3 Raten à <b class="mb-kl-amt"></b> – 0 % Zinsen mit '+
      '<img class="mb-kl-logo" alt="Klarna" src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg" '+
      'onerror="this.outerHTML=&quot;<span class=\\&quot;mb-kl-fallback\\&quot;>Klarna</span>&quot;">';
    price.appendChild(el);
    return el;
  }
  function updateKlarna(p){
    var el=getKlarnaEl(); if(!el) return;
    var amt=el.querySelector(".mb-kl-amt"); if(amt) amt.textContent=EUR(p/3);
  }

  function init(){
    injectMbStyle();
    update(false); // allinea prezzo/etichetta al formato preselezionato, senza muovere la galleria
    setupSticky();
    document.addEventListener("change", e=>{
      if(e.target && typeof e.target.name==="string" && e.target.name.indexOf("Format")===0) update(true);
    });
  }
  if(document.readyState!=="loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();
